import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RadioComponentDef } from '@df/ui/form/radio/radio.component.def';
@Component({
    selector: 'radio',
    templateUrl: './radio.html',
    styleUrls: ['radio.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgClass]
})
export class RadioComponent extends RadioComponentDef {
    @Input()
    top?: boolean;
}
